<ll-titulo>Pruebas propias</ll-titulo>
<menu-asignaturas-horizontal
    [asignaturaId]="asignaturaId"
    [tipoEvaluacion]="tipoInstrumento"
    (asignaturaChanged)="asignaturaId = $event"
></menu-asignaturas-horizontal>
<br />
<pruebas-propias [asignaturaId]="asignaturaId" [evaluacionTipo]="tipoInstrumento"></pruebas-propias>
